import styled, {css} from "styled-components";
import {HEADER_Z_INDEX} from "../../../header/header-consts";

interface IBottomStickyNavbarContainerBoxProps {
  shouldElevate: boolean;
}


export const BottomNavigationBarContainerDefaultBox = styled.div<IBottomStickyNavbarContainerBoxProps>`
  position: fixed;
  bottom: 0;
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width: calc(100% - env(safe-area-inset-right) - env(safe-area-inset-left));
  }
  
  touch-action: none;
  z-index: ${HEADER_Z_INDEX};

  ${props => props.shouldElevate && css`
    z-index: 115;
  `}
`;
